/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".daily-news-modal .modal-dialog{width:37.5rem}.daily-news-modal .modal-content{border-radius:1rem;overflow:hidden;border:none;width:37.5rem}.daily-news-modal-iframe{width:37.5rem;display:block}"];
export { styles as styles };
//# sourceMappingURL=daily-news-modal.component.scss.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/daily-news-modal/daily-news-modal.component.scss.ngstyle.js
// module id = 1361
// module chunks = 27 28 29